export const AVATAR_COLORS = [
  '#0ea47a', '#5e9be6', '#f59e0b', '#ef4444',
  '#a78bfa', '#f472b6', '#fb923c', '#22d3ee',
]
